export enum QuestTileFilterOption {
  All = "All",
  Live = "Live",
  ComingSoon = "Coming Soon",
  Ended = "Ended",
  MyCompletedQuests = "My Completed Quests",
}

export type TileFilterOption = QuestTileFilterOption;

export const questFilterOptions = Object.values(QuestTileFilterOption);
